module.exports = __webpack_public_path__ + "img/tu9.41a81d9e.png";